import { render, staticRenderFns } from "./AddDiscountCoupons.vue?vue&type=template&id=0c9fee72&"
import script from "./AddDiscountCoupons.vue?vue&type=script&lang=js&"
export * from "./AddDiscountCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports